/**
 * Symbol that can be used to represent all states or events.
 */
export const All = Symbol('All') as any;
